import {Controller} from "stimulus";
import AutoNumeric from "autonumeric";

let numberElements;
export default class extends Controller {

    connect() {
        console.log("log from license controller");
        numberElements = new AutoNumeric.multiple([...document.querySelectorAll('.money-cell')], {currencySymbol: '$'});
    }

    selectClassification(e) {
        const licenseId = document.querySelector("#license_id").value;
        const classificationTypeId = e.currentTarget.id;
        const formWindow = e.currentTarget.closest(".popup-form");
        fetch(licenseId + "/update_classification.js?classification_id=" + classificationTypeId)
            .then(response => {
                return response.text();
            })
            .then(html => {
                document.querySelector(".license-classification-area").innerHTML = html;
                formWindow.classList.remove("editing");
            })

    }

    calculateAdjustment(e) {
        const licenseId = document.querySelector("#license_id").value;
        const additionalAmount = Number(AutoNumeric.getNumber(e.currentTarget.closest(".lic-calc-fields-area").querySelector(".lic-revenue-field")));
        const adjustmentId = e.currentTarget.closest(".lic-calc-fields-area").querySelector("#bl_license_adjustment_id").value;
        const description = e.currentTarget.closest(".lic-calc-fields-area").querySelector("#bl_license_adjustment_description").value;
        const formArea = e.currentTarget.closest(".license-adjustment-area");
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");
        e.preventDefault();
        console.log("calculating adjustment");
        fetch(licenseId + "/bl_license_adjustments/calculate_adjustment.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-CSRF-Token": csrfToken
            },
            body: "amount=" + additionalAmount + "&id=" + encodeURIComponent(adjustmentId) + "&description=" + encodeURIComponent(description)
        })
            .then(response => {
                return response.text();
            })
            .then(html => {
                formArea.innerHTML = html;
                const newAdjustmentField = new AutoNumeric("#bl_license_adjustment_units_adjustment", {currencySymbol: '$'});
                let resultNumber = Number(formArea.querySelector("#amountDue").innerText).toFixed(2);
                const actionsArea = formArea.querySelector(".add-charge-area");
                actionsArea.classList.remove("hidden");
                const addChargeButton = formArea.querySelector(".add-charge-button");
                if (Number(resultNumber) > 0.0) {
                    addChargeButton.classList.remove("hidden");
                } else {
                    addChargeButton.classList.add("hidden");
                }
            })

    }

    saveAdjustment(e) {
        e.preventDefault();
        const fieldsArea = e.currentTarget.closest(".lic-calc-fields-area");
        const popupForm = e.currentTarget.closest(".popup-form");
        const adjustmentId = fieldsArea.querySelector("#bl_license_adjustment_id").value;
        const description = fieldsArea.querySelector("#bl_license_adjustment_description").value;
        const unitsAdjustment = AutoNumeric.getNumericString(fieldsArea.querySelector(".lic-revenue-field"));
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");

        fetch(`/bl_license_adjustments/${adjustmentId}.json`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken,
                "Accept": "application/json"
            },
            body: JSON.stringify({
                bl_license_adjustment: {
                    description: description,
                    units_adjustment: unitsAdjustment
                }
            })
        })
            .then(response => {
                if (response.ok) {
                    if (popupForm) {
                        popupForm.classList.remove("editing");
                    }
                    this.reloadPage();
                } else {
                    return response.json().then(data => {
                        const feedbackArea = fieldsArea.querySelector(".feedback-area");
                        const message = (data.errors || []).join(", ") || "Failed to save adjustment.";
                        feedbackArea.textContent = "";
                        const p = document.createElement("p");
                        p.className = "text-rose-600 text-sm";
                        p.textContent = message;
                        feedbackArea.appendChild(p);
                    });
                }
            })
            .catch(() => {
                const feedbackArea = fieldsArea.querySelector(".feedback-area");
                feedbackArea.textContent = "";
                const p = document.createElement("p");
                p.className = "text-rose-600 text-sm";
                p.textContent = "Failed to save adjustment. Please try again.";
                feedbackArea.appendChild(p);
            });
    }

    reloadPage() {
        window.location.reload();
    }

    changeLicenseType(e) {
        const licenseId = document.querySelector("#license_id").value;
        const newLicenseTypeId = e.target.value;
        const newLicenseTypeDescription = e.target.selectedOptions[0].text;
        const licenseTypeLabel = document.querySelector(".legacy-identifier");
        const licenseSelect = document.getElementById('entry_type');
        const formWindow = e.currentTarget.closest(".popup-form");
        console.log("updating license_type: " + newLicenseTypeId + " " + newLicenseTypeDescription)
        fetch(licenseId + '/update_license_type?new_type=' + newLicenseTypeId)
            .then(response => {
                return response.text();
            })
            .then(html => {
                licenseTypeLabel.innerText = newLicenseTypeDescription
                licenseSelect.value = newLicenseTypeId
                formWindow.classList.remove("editing");
            })
    }

}
